export default __webpack_public_path__ + "static/media/dropdown-arrow.7d18bbad.svg";